import {
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'Remark',
  props: {
    type: '',
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('appointment', {
      remark: 'getRemark',
    }),
    remarkValue: {
      get() {
        return this.remark;
      },
      set(newModel) {
        if (newModel != null) {
          this.setRemarkMutation(newModel);
        }

        return newModel;
      },
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setRemarkMutation: 'SET_REMARK',
    }),
  },
};
